import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { notification } from "antd";

export const vacancySlice = createSlice({
  name: "vacancy",
  initialState: {
    vacancyList: [],
  },
  reducers: {
    setVacancyList: (state, action) => {
      state.vacancyList = action.payload;
    },

    deleteVacancy: (state, action) => {
      state.vacancyList = state.vacancyList.filter(
        (x) => x.id !== action.payload
      );
    },

    toggleVacancy: (state, action) => {
      let vacancy = state.vacancyList.find((x) => x.id === action.payload);
      vacancy.isPublished = !vacancy.isPublished;
    },

    updateVacancy: (state, action) => {
      const { id, title, description, category } = action.payload;
      let vacancy = state.vacancyList.find((x) => x.id === id);
      vacancy.title = title;
      vacancy.description = description;
      vacancy.category = category;
    },
  },
});

export const { setVacancyList, deleteVacancy, toggleVacancy, updateVacancy } =
  vacancySlice.actions;

export const selectVacancies = (state) => state.vacancy.vacancyList;

export default vacancySlice.reducer;

export const getVacancyList =
  (startDate, endDate, searchKeyword, pageNumber, pageSize, callback) =>
  (dispatch) => {
    axios
      .get("vacancy/getList", {
        params: {
          startDate,
          endDate,
          searchKeyword,
          pageNumber,
          pageSize,
        },
      })
      .then(({ data }) => {
        dispatch(setVacancyList(data.vacancies));
        callback && callback(data.totalCount);
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };

export const deleteVacancyById = (id, callback) => (dispatch) => {
  axios
    .delete(`vacancy/${id}`)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(deleteVacancy(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const toggleVacancyById = (id, callback) => (dispatch) => {
  axios
    .patch(`vacancy/togglePublish/${id}`)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(toggleVacancy(id));
      callback && callback();
    })
    .catch((error) => {
      debugger;
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const createVacancy = (formData, callback) => (dispatch) => {
  axios
    .post("vacancy/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      notification.success({ message: data.message });
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const updateVacancyById = (id, vacancyData, callback) => (dispatch) => {
  axios
    .put(`vacancy/${id}`, vacancyData)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(updateVacancy(vacancyData));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};
